/* eslint-disable */
import axios from "../index";

const getGender = () => {
   return axios.get('selects/gender')
}

const getEntrepreneurship = () => {
   return axios.get('selects/entrepreneurship')
}

const getWorkspace = () => {
   return axios.get('selects/workspace')
}

const getPosition = () => {
   return axios.get('selects/position')
}

const getMarital = () => {
   return axios.get('selects/marital')
}

const getSubject = () => {
   return axios.get('selects/subject')
}

const api = { getGender, getEntrepreneurship, getWorkspace, getPosition, getMarital, getSubject }

export default api;